import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import NoDonations from '@client/containers/donationsCard/noDonations/NoDonations';
import DonationList from '@client/containers/donationsCard/donationList/DonationList';
import { reverseRoutes } from '@client/pages/reverseRoutes';
import ReactLink from '@client/components/reactLink/ReactLink';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './donationsCard.scss';

export default function DonationsCard(props) {
  const { fundraiser, donations } = props;

  return (
    <div className={styles.donationsCard}>
      <h3>Gåvor</h3>
      {donations && donations.size > 0 ? (
        <DonationList donations={donations} />
      ) : (
        <NoDonations />
      )}
      <ReactLink
        className={`${styleHelper.btnPrimaryMd} ${styleHelper.layoutMobileSideMargin} ${styles.donateButton}`}
        to={reverseRoutes.donate({ fundraiserId: fundraiser.get('id') })}
      >
        Bidra till insamlingen
      </ReactLink>
    </div>
  );
}

DonationsCard.propTypes = {
  fundraiser: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
  }),
  donations: ImmutablePropTypes.list,
};
